module.exports = __webpack_public_path__ + "static/media/hotle-top@2x.f8473665.png";